/** Vilkon Test Drive — native, accessible dialog controller. */
(() => {
  if (window.__vilkonTestDriveControllerLoaded) return;
  window.__vilkonTestDriveControllerLoaded = true;

  const selector = 'dialog.vilkon-test-drive__dialog';
  let openingElement = null;

  const prepareDialog = (dialog) => {
    if (dialog.dataset.vtdInitialized === '1') return;
    dialog.dataset.vtdInitialized = '1';
    dialog.addEventListener('close', () => {
      if (!document.querySelector(`${selector}[open]`)) {
        document.documentElement.classList.remove('vilkon-test-drive-modal-open');
      }
      if (openingElement?.isConnected) openingElement.focus({ preventScroll: true });
      openingElement = null;
    });
    dialog.addEventListener('click', (event) => {
      // The native dialog receives clicks on the backdrop as clicks on itself.
      if (event.target === dialog) dialog.close();
    });
  };

  const openDialog = (dialog, trigger = null) => {
    if (!dialog || typeof dialog.showModal !== 'function') return;
    prepareDialog(dialog);
    openingElement = trigger;
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('vilkon-test-drive-modal-open');
    const currentUrl = dialog.querySelector('[data-vtd-current-url]');
    if (currentUrl) currentUrl.value = window.location.href;
    const firstField = dialog.querySelector('input:not([type="hidden"]):not([type="checkbox"])');
    firstField?.focus({ preventScroll: true });
  };

  document.addEventListener('click', (event) => {
    const openTrigger = event.target.closest('[data-vtd-open]');
    if (openTrigger) {
      event.preventDefault();
      const dialogId = openTrigger.getAttribute('data-vtd-open');
      const dialog = dialogId ? document.getElementById(dialogId) : null;
      if (dialog) openDialog(dialog, openTrigger);
      return;
    }
    const closeTrigger = event.target.closest('[data-vtd-close]');
    if (closeTrigger) {
      event.preventDefault();
      const dialog = closeTrigger.closest(selector);
      if (dialog?.open) dialog.close();
    }
  });

  const openSubmissionResults = (root = document) => {
    root.querySelectorAll(selector).forEach((dialog) => {
      prepareDialog(dialog);
      if (dialog.querySelector('[data-vtd-result]')) openDialog(dialog);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => openSubmissionResults(), { once: true });
  } else {
    openSubmissionResults();
  }
  document.addEventListener('shopify:section:load', (event) => openSubmissionResults(event.target));
})();
